export const BackofficeErrors = {
  NO_PAYMENT_PLAN_CREATED_ON_JUNIFER: "004",
  NO_PAYMENT_SCHEDULE_CREATED_ON_JUNIFER: "005",
  UNKNOWN_ERROR: "999",
} as const
